import { Pipe, PipeTransform } from '@angular/core';
import momenttz from 'moment-timezone';
import { Temporal } from '@js-temporal/polyfill';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {
    transform(duration: string | number | Temporal.Duration, showUnit: boolean = true): string {
        if (duration instanceof Temporal.Duration) {
            let durationStr = '';
            const { hours, minutes } = duration.round({ largestUnit: 'hour', smallestUnit: 'minute' });

            if (hours > 0) {
                durationStr += `${hours} h `;
            }
            return durationStr + `${minutes}` + (showUnit ? ' min' : '');
        }

        let durationStr = '';
        const mDuration = momenttz.duration(duration, 'ms');

        if (mDuration) {
            if (mDuration.hours() > 0) {
                durationStr += mDuration.hours() + ' h ';
            }
            const min = mDuration.minutes() <= 1 ? 1 : mDuration.minutes();
            durationStr += min + (showUnit ? ' min' : '');
        }

        return durationStr;
    }
}
